var _path, _rect, _rect2, _rect3, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _rect4, _ellipse3, _path6, _path7, _rect5, _ellipse4, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefit3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9575 182.877H210.354V185.205C210.354 187.414 208.563 189.205 206.354 189.205H24.9575C22.7484 189.205 20.9575 187.414 20.9575 185.205V182.877Z",
    fill: "#191A1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.2285,
    y: 174.419,
    width: 198.543,
    height: 8.32831,
    rx: 4.16415,
    fill: "white",
    stroke: "#191A1F",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8486,
    y: 46.1833,
    width: 36.8636,
    height: 124.432,
    rx: 5,
    fill: "white",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.002,
    y: 46.1833,
    width: 36.8636,
    height: 124.432,
    rx: 5,
    fill: "white",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1554,
    cy: 118.965,
    rx: 7.30241,
    ry: 10.5652,
    stroke: "#191A1F",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.4338,
    cy: 118.965,
    rx: 7.30241,
    ry: 10.5652,
    stroke: "#191A1F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8223 69.4014H59.1789",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8218 77.4807H59.1784",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2554 69.4014H98.612",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2559 77.4807H98.6125",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101.155,
    y: 46.1833,
    width: 36.8636,
    height: 124.432,
    rx: 5,
    fill: "white",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.587,
    cy: 118.965,
    rx: 7.30241,
    ry: 10.5652,
    stroke: "#191A1F",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.663 69.4014H137.02",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.662 77.4807H137.018",
    stroke: "#191A1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136.211,
    y: 52.0894,
    width: 39.7748,
    height: 127.326,
    rx: 5,
    transform: "rotate(-15 136.211 52.0894)",
    fill: "#191A1F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.64,
    cy: 118.602,
    rx: 7.30241,
    ry: 10.5652,
    transform: "rotate(-15 174.64 118.602)",
    fill: "#191A1F",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.886 74.9944L177.448 66.5374",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.978 82.7981L179.54 74.3412",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit3);
export default __webpack_public_path__ + "static/media/benefit3.34a939969b0fbd1fbb5c12968b28ba1f.svg";
export { ForwardRef as ReactComponent };